import React from 'react';
import Container from 'react-bootstrap/Container';

interface Props {
    children: React.ReactNode;
}

const AdminMainPanel = (props: Props) => (
    <Container fluid className="admin-main-panel">
        {props.children}
    </Container>
);

export default AdminMainPanel;
